import { useState, useRef } from "react";
import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  ComboboxButton,
} from "@headlessui/react";

import { useTable } from "storev2/tableStore";
import proxy from "api/proxy";
import { cn } from "tools/ui";
import { theme } from "theme/theme";
import { useIntl } from "react-intl";
import { ChevronDownIcon, TrashIcon } from "components/Icons";

function One2manyFilter(props) {
  const { getDomain, setDomain, reload } = useTable();
  const {
    name,
    model,
    data,
    placeholder,
    onChange,
    layout,
    storeId,
    filterField,
    filterFieldSearch,
    customModel,
  } = props;

  const intl = useIntl();
  const fieldName = filterFieldSearch ?? filterField;

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(
    typeof data === "object" && data?.id ? data : null,
  );

  const timeoutRef = useRef(null);

  // ---------------------------------------------------------
  // Buscar SIEMPRE desde Tryton
  // ---------------------------------------------------------

  async function getOptions(q = "") {
    const { data: res } = await proxy.search(
      customModel ?? model,
      [fieldName, "ilike", `%${q}%`],
      [fieldName],
      20,
    );

    setOptions(res || []);
  }

  function handleInput(e) {
    const q = e.target.value;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    if (q.length > 2) {
      timeoutRef.current = setTimeout(() => getOptions(q), 400);
    } else {
      setOptions([]);
    }
  }

  function handleChange(option) {
    setSelected(option);
    onChange?.(name, option);
  }

  function handleClear() {
    setSelected(null);
    setOptions([]);

    const currentDomainRaw = getDomain(layout, storeId);
    const currentDomain = Array.isArray(currentDomainRaw)
      ? currentDomainRaw
      : [];

    const prefixExact = `${name}.${filterField}`; // "lines.name"

    if (currentDomain.length === 0) {
      console.log("No hay domain previo al limpiar.");
      return;
    }

    const newDomain = currentDomain.map((group) => {
      if (Array.isArray(group[0]) && Array.isArray(group[0][0])) return group;
      return group.filter((condition) => {
        const field = condition?.[0];
        if (typeof field !== "string") return true;
        return field !== prefixExact;
      });
    });

    setDomain(newDomain);
    reload(storeId);
  }

  return (
    <div className="relative min-w-[180px]">
      <Combobox value={selected} onChange={handleChange}>
        <ComboboxInput
          className={cn(
            "w-full shadow-sm border border-gray-200 rounded-xl py-2 px-3 bg-white outline-none pr-8",
            theme.textColor,
          )}
          placeholder={
            placeholder ? intl.formatMessage({ id: placeholder }) : "Buscar..."
          }
          onChange={handleInput}
          displayValue={(v) => v?.name || ""}
        />

        {options.length > 0 && (
          <ComboboxOptions className="absolute z-50 mt-1 w-full bg-white rounded-md max-h-60 overflow-auto shadow-sm border border-gray-200 text-xs">
            {options.map((option) => (
              <ComboboxOption
                key={option.id}
                value={option}
                className={({ active }) =>
                  cn(
                    "p-2 cursor-pointer truncate uppercase",
                    active ? "bg-blue-100" : "bg-white",
                  )
                }
              >
                {option?.[fieldName] || option.name}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}

        <ComboboxButton
          as="div"
          className="absolute right-2 top-3 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            if (selected) handleClear();
            else getOptions("");
          }}
        >
          {selected ? (
            <TrashIcon className="fill-current text-rose-400 size-5" />
          ) : (
            <ChevronDownIcon className="fill-current text-gray-500 size-5" />
          )}
        </ComboboxButton>
      </Combobox>
    </div>
  );
}

export default One2manyFilter;
